import { Charts } from './Charts';
import PeopleChartsDataProvider from './contexts/PeopleChartsDataContext';

const PeopleWrapper = () => {
    return (
        <PeopleChartsDataProvider>
            <Charts />
        </PeopleChartsDataProvider>
    );
};

export default PeopleWrapper;
